import React, { useState } from 'react';
import api from '../../../utils/api';

const CreateUserForm = ({ onClose, onCreate }) => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
  });

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg('');

    try {
      await api.post('/api/users/create', formData);
      setResponseMsg('✅ Usuario creado correctamente');
      setFormData({
        first_name: '',
        last_name: '',
        email: '',
      });
      onCreate();
      onClose();
    } catch (err) {
      console.error(err);
      setResponseMsg('❌ Error al crear usuario');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto bg-white p-6 rounded-xl space-y-6">
      <div className="mb-6">
        <h2 className="text-2xl font-semibold text-gray-900">Crear Nuevo Usuario</h2>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Nombre *</label>
            <input
              name="first_name"
              type="text"
              value={formData.first_name}
              onChange={handleChange}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md p-3 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Ingrese el nombre"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Apellido *</label>
            <input
              name="last_name"
              type="text"
              value={formData.last_name}
              onChange={handleChange}
              required
              className="mt-1 block w-full border border-gray-300 rounded-md p-3 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Ingrese el apellido"
            />
          </div>
        </div>

        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700">Correo electrónico *</label>
          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="mt-1 block w-full border border-gray-300 rounded-md p-3 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Ingrese el correo electrónico"
          />
        </div>

        {responseMsg && (
          <p className={`text-sm text-center ${responseMsg.includes('✅') ? 'text-green-600' : 'text-red-600'}`}>
            {responseMsg}
          </p>
        )}

        <div className="mt-6 flex justify-between">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-100"
          >
            Cerrar
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? 'Creando...' : 'Crear Usuario'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateUserForm;